import { siteConfig } from "@/mocks/categories";

const stats = [
  { value: "14+", label: "Product Categories", suffix: "" },
  { value: "10K+", label: "Products Compared", suffix: "" },
  { value: "98%", label: "Accuracy Rate", suffix: "%" },
  { value: "24/7", label: "Updated Pricing", suffix: "" },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="lg:w-1/2">
            <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest font-[family-name:var(--font-label)]">
              Why Choose GTBuy
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-foreground-950 mt-2 mb-4 font-[family-name:var(--font-heading)] leading-tight">
              Smarter Shopping
              <br />
              <span className="italic">Starts Here</span>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg font-[family-name:var(--font-body)] font-light">
              The GTBuy spreadsheet system transforms how you shop online. By organizing product data into
              a structured comparison framework, you can instantly identify the best deals, avoid overpaying,
              and make confident purchasing decisions across any product category.
            </p>
            <a
              href={siteConfig.mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Start Comparing Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>

          <div className="lg:w-1/2 w-full">
            <div className="grid grid-cols-2 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-background-100 rounded-lg p-6 md:p-8 text-center hover:bg-background-200/70 transition-colors duration-300"
                >
                  <div className="text-3xl md:text-4xl font-bold text-foreground-950 font-[family-name:var(--font-heading)] mb-1">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-foreground-500 font-medium font-[family-name:var(--font-label)]">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}